import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, FeatureGroup, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import { EditControl } from "react-leaflet-draw";
import "leaflet-draw";

const Leaflet = ({
  setAreaState,
  areaState,
  defaultAreaLatLng,
  zoom = 6,
}: {
  setAreaState: (latLngs: { lat: number; lng: number }[] | undefined) => void;
  areaState: { lat: number; lng: number }[];
  defaultAreaLatLng: [number, number];
  zoom?: number;
}) => {
  const [editableFG, setEditableFG] = useState<any>(null);
  const mapRef: any = React.createRef();

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.setView(
        [defaultAreaLatLng[0] || 36.92448, defaultAreaLatLng[1] || 50.641372],
        zoom
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultAreaLatLng]);
  const onCreated = (e: any) => {
    const latLngs = e?.layer?._latlngs;
    setAreaState(latLngs[0]);
    if (editableFG) {
      editableFG.clearLayers();
    }
  };
  const onFeatureGroupReady = (reactFGref: any) => {
    setEditableFG(reactFGref);
  };

  const onDrawDelete = (e: any) => {
    setAreaState(undefined);
  };

  const defaultArea = {
    type: "FeatureCollection",
    features: [
      {
        type: "Feature",
        properties: {},
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [35.8189, -123.4786],
              [37.8199, -122.4786],
              [30.8199, -124.4776],
              [37.8189, -125.4776],
              [33.8189, -126.4786],
            ],
          ],
        },
      },
    ],
  };

  return (
    <MapContainer
      ref={mapRef}
      center={defaultAreaLatLng}
      zoom={6}
      zoomControl={false}
    >
      <TileLayer
        attribution='© <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
      />
      <FeatureGroup
        ref={(featureGroupRef) => {
          onFeatureGroupReady(featureGroupRef);
        }}
      >
        <EditControl
          draw={{
            polygon: areaState === undefined ? true : false,
            polyline: false,
            rectangle: false,
            circle: false,
            circlemarker: false,
            marker: false,
          }}
          position="topright"
          onCreated={onCreated}
          onDeleted={onDrawDelete}
          edit={{
            featureGroup: editableFG,
            edit: true,
            remove: true,
          }}
          {...{ geoJson: defaultArea }}
        />
      </FeatureGroup>
    </MapContainer>
  );
};
export default Leaflet;
